import { render, staticRenderFns } from "./PolicyViewQrAction.vue?vue&type=template&id=6ecdc99a"
import script from "./PolicyViewQrAction.vue?vue&type=script&lang=js"
export * from "./PolicyViewQrAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports